import React from 'react';
import PropTypes from 'prop-types';
import InputRange from 'common/components/modules/input-range';

const RangeSection = ({
   value,
   onChange,
   name,
   minValue,
   maxValue,
   step,
}) => {
   return (
      <div className='flex w-full h-5 items-center'>
         <InputRange
            onChange={ onChange }
            value={ value }
            name={ name }
            minValue={ minValue }
            maxValue={ maxValue }
            step={ step }
            withTyping={ false }
         />
      </div>
   )
}

RangeSection.propTypes = {
   value: PropTypes.any,
   onChange: PropTypes.func,
   name: PropTypes.string,
   minValue: PropTypes.number,
   maxValue: PropTypes.number,
   step: PropTypes.number,
};
RangeSection.defaultProps = {
   minValue: 0,
   maxValue: 100,
   step: 1,
}

export default RangeSection;
